import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
	CustomIconButton,
	CustomTooltip,
	DropDown,
	icon,
	IconComponent,
} from "../../../../../../../../common/components";
import styles from "./SummaryHandler.module.css";
import { DocumentService } from "../../../../../../../../api";
import { useApi } from "../../../../../../../../common/hooks";
import { translate } from "../../../../../../../../common/providers";

const SummaryHandler = () => {
	const { call: getInformation } = useApi(DocumentService.getInformation);
	const documentId = useSelector(({ srDocument }) => srDocument?.documentId);
	const [open, setOpen] = useState(false);
	const [summary, setSummary] = useState("");
	const anchorRef = useRef(null);
	useEffect(() => {
		getInformation({ docId: documentId })
			.then((data) =>
				setSummary(
					data.documentAttributeDTOs.find((attr) => attr.attributeKey === "AI_SUMMARY_LONG")
						?.attributeValue || ""
				)
			)
			.catch(console.error);
	}, [documentId, getInformation]);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	return (
		<CustomTooltip title={!summary ? translate("smart-review.summary-handler.summary.empty") : ""}>
			<span>
				<CustomIconButton
					ref={anchorRef}
					btnClassName={styles.btn}
					color="primary"
					disabled={!summary}
					icon={icon.faBookOpen}
					size="sm"
					variant="outlined"
					onClick={handleOpen}
				/>
				<DropDown ref={anchorRef} open={open} onClose={handleClose}>
					<div className={styles.dropDownContainer}>
						<div className={styles.title}>
							{translate(
								summary
									? "smart-review.summary-handler.summary"
									: "smart-review.summary-handler.summary.empty"
							)}
							<span className={styles.icon}>
								<IconComponent color="var(--blue-500)" icon={icon.faWandMagicSparkles} size="2xs" />
							</span>
						</div>
						<div>{summary}</div>
					</div>
				</DropDown>
			</span>
		</CustomTooltip>
	);
};

export default SummaryHandler;
